import { Redirect } from 'expo-router';
import React from 'react';

const GooglePayFundingScreen = () => <Redirect href="/" />;

export default GooglePayFundingScreen;
